/**
 * @generated SignedSource<<f1856c2c129ab32ef775b62270a59c86>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useGetDatesListData_staffProfile$data = {
  readonly availabilitySlots: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly date: string;
        readonly id: string;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "useGetDatesListData_staffProfile";
};
export type useGetDatesListData_staffProfile$key = {
  readonly " $data"?: useGetDatesListData_staffProfile$data;
  readonly " $fragmentSpreads": FragmentRefs<"useGetDatesListData_staffProfile">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "durationMins"
    },
    {
      "kind": "RootArgument",
      "name": "endDateTime"
    },
    {
      "kind": "RootArgument",
      "name": "endTime"
    },
    {
      "kind": "RootArgument",
      "name": "slotAvailability"
    },
    {
      "kind": "RootArgument",
      "name": "startDateTime"
    },
    {
      "kind": "RootArgument",
      "name": "startTime"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "useGetDatesListData_staffProfile",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "dateTimeGte",
          "variableName": "startDateTime"
        },
        {
          "kind": "Variable",
          "name": "dateTimeLte",
          "variableName": "endDateTime"
        },
        {
          "kind": "Variable",
          "name": "durationMins",
          "variableName": "durationMins"
        },
        {
          "kind": "Variable",
          "name": "slotAvailability",
          "variableName": "slotAvailability"
        },
        {
          "kind": "Variable",
          "name": "timeGte",
          "variableName": "startTime"
        },
        {
          "kind": "Variable",
          "name": "timeLte",
          "variableName": "endTime"
        }
      ],
      "concreteType": "AvailabilitySlotConnection",
      "kind": "LinkedField",
      "name": "availabilitySlots",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "AvailabilitySlotEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "AvailabilitySlot",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "date",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "StaffProfile",
  "abstractKey": null
};

(node as any).hash = "1eb44fcd48809d39b510623042dba38e";

export default node;
